<template>
  <filters-form
    :initial="initial"
    :scrollable="scrollable"

    :items="items"
    :loading="loading"
    :filters="filters"

    :schema="schema"
    :payload="payload"

    :actions="actions"
    :per-page="perPage"
  />
</template>

<script>
  import { mapState } from 'vuex';

  import form from '@cordel/helpers/form/mixin';

  import FiltersForm from '@sdk/components/Filters/Form.vue';

  /* eslint-disable import/no-extraneous-dependencies */
  import preload from '@/helpers/mixins/preload';
  import { INITIAL_STORES_FILTERS as INITIAL } from '@/store/modules/stores';
  /* eslint-enable import/no-extraneous-dependencies */

  import payloadGenerator from './payload';
  import schemaGenerator from './schema';

  export default {
    name: 'FilterStoresList',
    components: {
      FiltersForm,
    },
    mixins: [
      form,
      preload,
    ],
    props: {
      scrollable: {
        type: Boolean,
        default: true,
      },
      perPage: {
        type: Number,
        default: null,
      },
      overwrite: {
        type: Object,
        default: null,
      },
    },
    data() {
      return {
        schema: schemaGenerator(),
        payload: payloadGenerator(),

        initial: {},

        actions: {
          filter: 'stores/filter',
          clear: 'stores/clear',
          list: 'stores/list',
        },
      };
    },
    computed: {
      ...mapState([
        'stores',
      ]),

      items() {
        return this.stores.list.items;
      },
      loading() {
        return this.stores.list.loading;
      },
      filters() {
        return this.stores.list.filters;
      },
    },
    beforeMount() {
      this.initial = {
        ...INITIAL,
        ...this.overwrite,
      };
      this.$store.dispatch('stores/clear', { action: 'list' });
    },
  };
</script>
